import React, { useState } from "react";
import { addDoc, collection, getFirestore, serverTimestamp } from "firebase/firestore";

export default function DemoLeadGateModal({ mode, playbackTime, podcastId, onContinue, onSubmitted }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const required = mode === "required";

  const submit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await addDoc(collection(getFirestore(), "signups"), {
        email: email.trim(),
        message: message.trim(),
        source: "wui_cast_demo",
        podcastId,
        promptType: mode,
        playbackTime: Math.round(playbackTime),
        createdAt: serverTimestamp(),
      });
      onSubmitted();
    } catch (submissionError) {
      console.error("Demo contact submission failed:", submissionError);
      setError("We couldn't submit your details. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="demo-lead-gate" role="dialog" aria-modal="true" aria-labelledby="demo-lead-gate-title">
      <div className="demo-lead-gate-card">
        <div className="demo-lead-gate-badge">WUI-Cast demo</div>
        <h2 id="demo-lead-gate-title">
          {required ? "Want to keep listening?" : "We'd love your feedback"}
        </h2>
        <p>
          WUI-Go can create this experience for your community—using your content and multiple languages—to help residents understand why preparedness actions matter.
        </p>
        <p>{required ? "Tell us about your interest to continue." : "Tell us what brought you here, or keep listening without submitting."}</p>
        <form onSubmit={submit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Feedback or reason for interest
            <textarea
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              placeholder="What would you like to learn or explore?"
              rows="4"
              required
            />
          </label>
          {error && <p className="demo-lead-gate-error" role="alert">{error}</p>}
          <button className="demo-lead-gate-submit" type="submit" disabled={submitting}>
            {submitting ? "Submitting…" : required ? "Submit and continue" : "Submit feedback"}
          </button>
          {!required && (
            <button className="demo-lead-gate-continue" type="button" onClick={onContinue}>
              Keep listening
            </button>
          )}
          <a className="demo-lead-gate-exit" href="/">Exit demo</a>
        </form>
      </div>
    </div>
  );
}
